import { Link, useNavigate } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { useState } from "react";

export const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className="glass-nav fixed top-0 left-0 right-0 z-50" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="text-xl font-medium tracking-tight" data-testid="logo-link">
            N K BORKAR & CO.
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid="nav-home">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid="nav-about">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid="nav-services">
              Services
            </button>
            <button onClick={() => scrollToSection('industries')} className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid="nav-industries">
              Industries
            </button>
            <button onClick={() => scrollToSection('experience')} className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid="nav-experience">
              Experience
            </button>
            <a href="https://game.nkborkar.com" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
  Game
</a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden" data-testid="mobile-menu-toggle">
            {mobileMenuOpen ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200" data-testid="mobile-menu">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left py-2 text-sm font-medium text-slate-700" data-testid="mobile-nav-home">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 text-sm font-medium text-slate-700" data-testid="mobile-nav-about">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left py-2 text-sm font-medium text-slate-700" data-testid="mobile-nav-services">
              Services
            </button>
            <button onClick={() => scrollToSection('industries')} className="block w-full text-left py-2 text-sm font-medium text-slate-700" data-testid="mobile-nav-industries">
              Industries
            </button>
            <button onClick={() => scrollToSection('experience')} className="block w-full text-left py-2 text-sm font-medium text-slate-700" data-testid="mobile-nav-experience">
              Experience
            </button>
            <a href="https://game.nkborkar.com" target="_blank" rel="noopener noreferrer" className="block w-full text-left py-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
  Game
</a>       
               </div>
        </div>
      )}
    </nav>
  );
};